import React from 'react'
import t from '~t'
import links from '~config/links'

import { Button, Section, SectionTitle, SectionActions, Icon } from '~ui';

export default function SearchMenuHelp() {
    return (
        <Section className={'ui-search-help'}>
            <SectionTitle className={'ui-search-help-tip'}>
                {t.s('putDashToExclude')}
            </SectionTitle>

            <SectionActions className={'ui-search-help-actions'}>
                <Button variant='ghost'
                    href={links.help.search}
                    target='_blank'>
                    <Icon name='help' />
                </Button>
            </SectionActions>
        </Section>
    )
}